var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/observable/of';
import { empty } from 'rxjs/observable/empty';
import { map } from 'rxjs/operators/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { startWith } from 'rxjs/operators/startWith';
import { tap } from 'rxjs/operators/tap';
import { endOfDay, getMonth, getYear, isWithinRange, parse } from 'date-fns';
import { SessionStorageService, SessionStorage } from '../jng2-webstorage/app';
import { ConfigService } from '../config/config.service';
var ApplicationService = /** @class */ (function () {
    // #endregion
    function ApplicationService(http, configService, storage) {
        this.http = http;
        this.configService = configService;
        this.storage = storage;
        this.AllCollegesSubject = new BehaviorSubject(null);
        this.CurrentSchoolSubject = new BehaviorSubject(null);
        this.CurrentSchoolYearSubject = new BehaviorSubject('');
        this.DevSiteSubject = new BehaviorSubject(false);
        this.ParentStudentChildrenSubject = new BehaviorSubject(null);
        this.SelectedAdminCollegeIDSubject = new BehaviorSubject(2);
        this.SelectedSchoolYearSubject = new BehaviorSubject('');
        this.SelectedStudentSubject = new BehaviorSubject(null);
        if (this._AllColleges) {
            this.AllColleges = this._AllColleges;
        }
        if (this._CurrentSchool) {
            this.CurrentSchool = this._CurrentSchool;
        }
        if (this._CurrentSchoolYear) {
            this.CurrentSchoolYear = this._CurrentSchoolYear;
        }
        if (this._SelectedAdminCollegeID) {
            this.SelectedAdminCollegeID = this._SelectedAdminCollegeID;
        }
        if (this._SelectedSchoolYear) {
            this.SelectedSchoolYear = this._SelectedSchoolYear;
        }
        if (this._SelectedStudent) {
            this.SelectedStudent = this._SelectedStudent;
        }
        this.DevSite = window.location.hostname.indexOf('localhost') >= 0 || window.location.hostname.indexOf('deltadev') >= 0;
    }
    Object.defineProperty(ApplicationService.prototype, "AllColleges", {
        // #region Getters and Setters for Subjects
        get: function () {
            return this.AllCollegesSubject.value;
        },
        set: function (value) {
            var data = (value || []).slice();
            this.AllCollegesSubject.next(data);
            this._AllColleges = data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "CurrentSchool", {
        get: function () {
            return this.CurrentSchoolSubject.value;
        },
        set: function (value) {
            this.CurrentSchoolSubject.next(value);
            this._CurrentSchool = this.CurrentSchoolSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "CurrentSchoolYear", {
        get: function () {
            return this.CurrentSchoolYearSubject.value;
        },
        set: function (value) {
            this.CurrentSchoolYearSubject.next(value);
            this._CurrentSchoolYear = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "DevSite", {
        get: function () {
            return this.DevSiteSubject.value;
        },
        set: function (value) {
            this.DevSiteSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "ParentStudentChildren", {
        get: function () {
            return this.ParentStudentChildrenSubject.value;
        },
        set: function (value) {
            this.ParentStudentChildrenSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "SelectedAdminCollegeID", {
        get: function () {
            return this.SelectedAdminCollegeIDSubject.value;
        },
        set: function (value) {
            this.SelectedAdminCollegeIDSubject.next(value);
            this._SelectedAdminCollegeID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "SelectedSchoolYear", {
        get: function () {
            return this.SelectedSchoolYearSubject.value;
        },
        set: function (value) {
            this.SelectedSchoolYearSubject.next(value);
            this._SelectedSchoolYear = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationService.prototype, "SelectedStudent", {
        get: function () {
            return this.SelectedStudentSubject.value;
        },
        set: function (value) {
            this.SelectedStudentSubject.next(value);
            this._SelectedStudent = value;
        },
        enumerable: true,
        configurable: true
    });
    // #region Add Adoption Request Service Call
    ApplicationService.prototype.AddAdoptionRequest = function (AuthToken, CurrentRole, Request, Colleges) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/AddAdoptionRequest", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            Colleges: (Colleges || []).toString() || '',
            Request: Request || '',
        });
    };
    // #endregion
    // #region Add College Contact Service Call
    ApplicationService.prototype.AddCollegeContact = function (AuthToken, CollegeID, Email) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/AddCollegeContact", {
            AuthToken: AuthToken || '',
            CollegeID: CollegeID || '',
            Email: Email || '',
        });
    };
    // #endregion
    // #region Add College Staff To College Service Call
    ApplicationService.prototype.AddCollegeStaffToCollege = function (AuthToken, UserID, CollegeID, AccessLevel) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/AddCollegeStaffToCollege?AuthToken=" + (AuthToken || '') + "&UserID=" + (UserID || '') + "&CollegeID=" + (CollegeID || '') + "&AccessLevel=" + (AccessLevel != null ? AccessLevel : '')));
    };
    // #endregion
    // #region Add Eligible Course Service Call
    ApplicationService.prototype.AddEligibleCourse = function (AuthToken, Prefix, Code, Colleges) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/AddEligibleCourse?AuthToken=" + (AuthToken || '') + "&Prefix=" + (Prefix || '') + "&Code=" + (Code || '') + "&Colleges=" + (Colleges || '')));
    };
    // #endregion
    // #region Add Eligible Course College Service Call
    ApplicationService.prototype.AddEligibleCourseCollege = function (AuthToken, EligibleCourseID, CollegeID) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/AddEligibleCourseCollege", {
            AuthToken: AuthToken || '',
            EligibleCourseID: EligibleCourseID,
            CollegeID: CollegeID,
        });
    };
    // #endregion
    // #region Add Term Window To College Service Call
    ApplicationService.prototype.AddTermWindowToCollege = function (AuthToken, CollegeID, CollegeSchoolYear, TermCode, DateBegin, DateEnd) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/AddTermWindowToCollege?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '') + "&CollegeSchoolYear=" + (CollegeSchoolYear || '') + "&TermCode=" + (TermCode || '') + "&DateBegin=" + (DateBegin != null ? DateBegin.toJSON() : '') + "&DateEnd=" + (DateEnd != null ? DateEnd.toJSON() : '')))
            .pipe(map(function (res) {
            var resdata = res || [];
            resdata.forEach(function (data) {
                data.DateBegin = data.DateBegin != null ? new Date(data.DateBegin) : null;
                data.DateEnd = data.DateEnd != null ? new Date(data.DateEnd) : null;
            });
            return resdata;
        }));
    };
    // #endregion
    // #region Add Student College Record Service Call
    ApplicationService.prototype.AddStudentCollegeRecord = function (AuthToken, StudentID, UserID, SchoolYear, TermWindowID, CollegeID, CounselorSAPID, FormStatus) {
        var self = this;
        // Preparse the SchoolYear parameter here. If it is YYYYZZZZ format, bring it down to YYZZ before sending along.
        if (SchoolYear.length === 8) {
            SchoolYear = SchoolYear.substr(2, 2) + SchoolYear.substr(6, 2);
        }
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/AddStudentCollegeRecord?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&UserID=" + (UserID || '') + "&SchoolYear=" + (SchoolYear || '') + "&TermWindowID=" + (TermWindowID || '') + "&CollegeID=" + (CollegeID || '') + "&CounselorSAPID=" + (CounselorSAPID || '') + "&FormStatus=" + (FormStatus || '')))
            .pipe(map(function (res) {
            // Establish the original counselor SAPID before handing back to client
            if (res && res.Requests && res.Requests.length) {
                res.Requests.forEach(function (data) {
                    data.OriginalCounselorSAPID = data.CounselorSAPID;
                    data.DualEnrollmentProgram = self.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                    data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                    data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                    data.AvailableTerms = data.AvailableTerms || [];
                    data.AnyOpenTerms =
                        data.AvailableTerms.findIndex(function (item) {
                            return item.CurrentlyAvailable === true;
                        }) >= 0;
                    // Process all date objects into dates
                    data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                    data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                    data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                    data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                    data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                    data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                    if (data.Term) {
                        data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                        data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                    }
                    if (data.AvailableTerms && data.AvailableTerms.length) {
                        data.AvailableTerms.forEach(function (tdata) {
                            tdata.DateBegin = tdata.DateBegin ? new Date(tdata.DateBegin) : null;
                            tdata.DateEnd = tdata.DateEnd ? new Date(tdata.DateEnd) : null;
                        });
                    }
                });
            }
            return res;
        }));
    };
    // #endregion
    // #region Add Student College Record Course Service Call
    ApplicationService.prototype.AddStudentCollegeRecordCourse = function (AuthToken, DualEnrollStudentID, CourseID, AddedBy, PriorityRequest) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/AddStudentCollegeRecordCourse?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CourseID=" + (CourseID || '') + "&AddedBy=" + (AddedBy || '') + "&PriorityRequest=" + (PriorityRequest || '')))
            .pipe(map(function (res) {
            if (res) {
                var data = res.Requests;
                if (data && data.length) {
                    data.forEach(function (d) {
                        // Create the full coded name for each course choice returned
                        d.FullCode = d.Prefix + ' ' + d.Code;
                        d.DateCreated = d.DateCreated ? new Date(d.DateCreated) : null;
                        d.DateRemoved = d.DateRemoved ? new Date(d.DateRemoved) : null;
                        d.DateScheduled = d.DateScheduled ? new Date(d.DateScheduled) : null;
                    });
                }
                if (res.Notes && res.Notes.length) {
                    res.Notes.forEach(function (note) {
                        note.NoteDate = note.NoteDate ? new Date(note.NoteDate) : null;
                    });
                }
            }
            return res;
        }));
    };
    // #endregion
    // #region Add Student College Record Note Service Call
    ApplicationService.prototype.AddStudentCollegeRecordNote = function (AuthToken, DualEnrollStudentID, Note, NoteVisible) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/AddStudentCollegeRecordNote", {
            AuthToken: AuthToken,
            DualEnrollStudentID: DualEnrollStudentID,
            Note: Note,
            NoteVisible: NoteVisible,
        })
            .pipe(map(function (res) {
            var data = (res || []).slice();
            data.forEach(function (item) {
                item.NoteDate = item.NoteDate ? new Date(item.NoteDate) : null;
            });
            return data;
        }));
    };
    // #endregion
    // #region Add Web App Issue Alert Service Call
    ApplicationService.prototype.AddWebAppIssueAlert = function (AuthToken, CurrentRole, AlertMessage, DateBegin, DateEnd) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/AddWebAppIssueAlert", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            AlertMessage: AlertMessage || '',
            DateBegin: DateBegin ? DateBegin.toISOString() : '',
            DateEnd: DateEnd ? DateEnd.toISOString() : '',
        })
            .pipe(map(function (alerts) {
            if (alerts && !!alerts.length) {
                alerts.forEach(function (alert) {
                    alert.DateBegin = alert.DateBegin ? new Date(alert.DateBegin) : null;
                    alert.DateEnd = alert.DateEnd ? new Date(alert.DateEnd) : null;
                    alert.LastUpdated = alert.LastUpdated ? new Date(alert.LastUpdated) : null;
                });
            }
            return alerts;
        }));
    };
    // #endregion
    // #region Add Web App Issue Type Service Call
    ApplicationService.prototype.AddWebAppIssueType = function (AuthToken, CurrentRole, DisplayText, RequiresDescription) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/AddWebAppIssueType", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            DisplayText: DisplayText || '',
            RequiresDescription: RequiresDescription || '',
        });
    };
    // #endregion
    // #region Advisor Update Student College Record Service Call
    ApplicationService.prototype.AdvisorUpdateStudentCollegeRecord = function (AuthToken, StudentID, DualEnrollStudentID, StaffID, FormStatus, Approved, ReturnNote) {
        var _this = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/AdvisorUpdateStudentCollegeRecord", {
            AuthToken: AuthToken || '',
            StudentID: StudentID || '',
            DualEnrollStudentID: DualEnrollStudentID || '',
            StaffID: StaffID || '',
            FormStatus: FormStatus || '',
            Approved: Approved != null ? Approved : '',
            ReturnNote: ReturnNote || '',
        })
            .pipe(map(function (res) {
            // Establish the original counselor SAPID before handing back to client
            if (res && res.length) {
                res.forEach(function (data) {
                    data.OriginalCounselorSAPID = data.CounselorSAPID;
                    data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                    data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                    data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                    data.AvailableTerms = data.AvailableTerms || [];
                    data.AnyOpenTerms =
                        data.AvailableTerms.findIndex(function (item) {
                            return item.CurrentlyAvailable === true;
                        }) >= 0;
                    // Process all date objects into dates
                    data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                    data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                    data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                    data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                    data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                    data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                    if (data.Term) {
                        data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                        data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                    }
                    if (data.AvailableTerms && data.AvailableTerms.length) {
                        data.AvailableTerms.forEach(function (d) {
                            d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                            d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                        });
                    }
                });
            }
            return res;
        }));
    };
    // #endregion
    // #region Advisor Update Student College Records Service Call
    ApplicationService.prototype.AdvisorUpdateStudentCollegeRecords = function (AuthToken, StudentID, DualEnrollStudentID, StaffID, FormStatus, Approved, ReturnNote, Courses) {
        var _this = this;
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/AdvisorUpdateStudentCollegeRecords", {
            AuthToken: AuthToken || '',
            StudentID: StudentID || '',
            DualEnrollStudentID: DualEnrollStudentID || '',
            StaffID: StaffID || '',
            FormStatus: FormStatus || '',
            Approved: Approved != null ? Approved : '',
            ReturnNote: ReturnNote || '',
            Courses: Courses || '',
        })
            .pipe(map(function (res) {
            // Establish the original counselor SAPID before handing back to client
            if (res && res.length) {
                res.forEach(function (data) {
                    data.OriginalCounselorSAPID = data.CounselorSAPID;
                    data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                    data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                    data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                    data.AvailableTerms = data.AvailableTerms || [];
                    data.AnyOpenTerms =
                        data.AvailableTerms.findIndex(function (item) {
                            return item.CurrentlyAvailable === true;
                        }) >= 0;
                    // Process all date objects into dates
                    data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                    data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                    data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                    data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                    data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                    data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                    if (data.Term) {
                        data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                        data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                    }
                    if (data.AvailableTerms && data.AvailableTerms.length) {
                        data.AvailableTerms.forEach(function (d) {
                            d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                            d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                        });
                    }
                });
            }
            return res;
        }));
    };
    // #endregion
    // #region Approve Adoption Request Service Call
    ApplicationService.prototype.ApproveAdoptionRequest = function (AuthToken, CurrentRole, AdoptionRequestID) {
        return this.http
            .get(this.configService.hostAddress + "Api/Services/DELTA/ApproveAdoptionRequest?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&AdoptionRequestID=" + (AdoptionRequestID || ''))
            .pipe(map(function (body) {
            if (body && body.length) {
                body.forEach(function (item) {
                    item.DateRequested = item.DateRequested ? new Date(item.DateRequested) : null;
                    item.DateReviewed = item.DateReviewed ? new Date(item.DateReviewed) : null;
                });
            }
            return body;
        }));
    };
    // #endregion
    // #region Approve College Agreement Service Call
    ApplicationService.prototype.ApproveCollegeAgreement = function (AuthToken, StudentID, CollegeID, SchoolYear, TermWindowID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/ApproveCollegeAgreement?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&CollegeID=" + (CollegeID || '') + "&SchoolYear=" + (SchoolYear || '') + "&TermWindowID=" + (TermWindowID || '')));
    };
    // #endregion
    // #region Approve Terms Agreements Service Call
    ApplicationService.prototype.ApproveTermsAgreements = function (AuthToken, StudentID, CollegeID, SchoolYear, TermWindowID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/ApproveTermsAgreements?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&CollegeID=" + (CollegeID || '') + "&SchoolYear=" + (SchoolYear || '') + "&TermWindowID=" + (TermWindowID || '')))
            .pipe(map(function (terms) {
            if (terms && !!terms.length) {
                terms.forEach(function (term) {
                    term.DateApproved = term.DateApproved ? new Date(term.DateApproved) : null;
                });
            }
            return terms;
        }));
    };
    // #endregion
    // #region Clear Selected Student Service Call
    ApplicationService.prototype.ClearSelectedStudent = function (AuthToken) {
        var self = this;
        self.SelectedStudent = null;
    };
    // #endregion
    // #region Deny Adoption Request Service Call
    ApplicationService.prototype.DenyAdoptionRequest = function (AuthToken, CurrentRole, AdoptionRequestID) {
        return this.http
            .get(this.configService.hostAddress + "Api/Services/DELTA/DenyAdoptionRequest?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&AdoptionRequestID=" + (AdoptionRequestID || ''))
            .pipe(map(function (body) {
            if (body && body.length) {
                body.forEach(function (item) {
                    item.DateRequested = item.DateRequested ? new Date(item.DateRequested) : null;
                    item.DateReviewed = item.DateReviewed ? new Date(item.DateReviewed) : null;
                });
            }
            return body;
        }));
    };
    // #endregion
    // #region Get Accelerated Degree Programs Service Call
    ApplicationService.prototype.GetAcceleratedDegreePrograms = function (AuthToken) {
        var self = this;
        if (!self._AcceleratedPrograms) {
            // Load what we need.
            return this.http
                .get(this.configService.hostAddress + ("Api/Services/DELTA/GetAcceleratedDegreePrograms?AuthToken=" + (AuthToken || '')))
                .pipe(tap(function (res) {
                self._AcceleratedPrograms = res;
            }));
        }
        else {
            return of(self._AcceleratedPrograms);
        }
    };
    // #endregion
    // #region Get Agreement Approval Text Service Call
    ApplicationService.prototype.GetAgreementApprovalText = function (AuthToken, CollegeID, TermWindowID, StudentID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetAgreementApprovalText?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '') + "&TermWindowID=" + (TermWindowID || '') + "&StudentID=" + (StudentID || '')))
            .pipe(map(function (res) {
            if (!res) {
                return res;
            }
            var data = JSON.parse(JSON.stringify(res));
            data.DateCreated = data.DateCreated ? new Date(data.DateCreated) : null;
            data.CollegeID = CollegeID;
            return data;
        }));
    };
    // #endregion
    // #region Get All Adoption Requests Service Call
    ApplicationService.prototype.GetAllAdoptionRequests = function (AuthToken, CurrentRole) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetAllAdoptionRequests?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '')))
            .pipe(map(function (body) {
            if (body && body.length) {
                body.forEach(function (item) {
                    item.DateRequested = item.DateRequested ? new Date(item.DateRequested) : null;
                    item.DateReviewed = item.DateReviewed ? new Date(item.DateReviewed) : null;
                });
            }
            return body;
        }));
    };
    // #endregion
    // #region Get All College Staff For College Service Call
    ApplicationService.prototype.GetAllCollegeStaffForCollege = function (AuthToken, CollegeID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetAllCollegeStaffForCollege?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '')));
    };
    // #endregion
    // #region Get All Colleges Service Call
    ApplicationService.prototype.GetAllColleges = function (AuthToken) {
        var self = this;
        if (!self._AllColleges) {
            // Load what we need.
            return this.http
                .get(this.configService.hostAddress + ("Api/Services/DELTA/GetAllColleges?AuthToken=" + (AuthToken || '')))
                .pipe(tap(function (res) {
                self._AllColleges = res;
            }));
        }
        else {
            // Return what we loaded already.
            return of(self._AllColleges);
        }
    };
    // #endregion
    // #region Get All College Contacts Service Call
    ApplicationService.prototype.GetAllCollegeContacts = function (AuthToken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/DELTA/GetAllCollegeContacts?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Get All College Years Service Call
    ApplicationService.prototype.GetAllCollegeYears = function () {
        var self = this;
        if (!self._AllCollegeYears) {
            // We do not have what we need loaded yet. Load it now.
            return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetAllSchoolYears").pipe(map(function (res) {
                var years = res;
                self._AllSchoolYears = years;
                // Process a list of all possible college school years. By design, this will be in 20## format, and will
                // extend to 1 year beyond the current PCPS year.
                // This is to accommodate colleges which refer to their Fall terms as the following year. For example,
                // a class running in Fall of the 2016 calendar year may be referred to as the "Fall 2017" college year.
                var collegeYears = [];
                // If we are in the spring term (January - June), add 1 to the year to ensure we are getting the next available year.
                var today = new Date();
                var offset = getMonth(today) <= 5 ? 1 : 0;
                if (self._AllSchoolYears && self._AllSchoolYears.length) {
                    var endyear = parseInt(years[0].substr(2, 2), 10) + offset;
                    var beginyear = parseInt(years[years.length - 1].substr(2, 2), 10);
                    for (var ci = endyear; ci >= beginyear; ci--) {
                        var newYear = '20' + ('00' + ci).slice(-2);
                        collegeYears.push(newYear);
                    }
                }
                self._AllCollegeYears = collegeYears;
                return collegeYears;
            }));
        }
        else {
            // We already have the list of all college years. Return it as an observable.
            return of(self._AllCollegeYears);
        }
    };
    // #endregion
    // #region Get All Courses At College Service Call
    ApplicationService.prototype.GetAllCoursesAtCollege = function (AuthToken, CollegeID, SchoolYear) {
        var self = this;
        if (self.CollegeCourses && self.CollegeCourses.length) {
            // Do we have a match to the requested combination already loaded?
            var foundCourses = self.CollegeCourses.findIndex(function (data) {
                return data.CollegeID === CollegeID && data.SchoolYear === SchoolYear;
            });
            if (foundCourses >= 0) {
                // Send this back.
                return empty().pipe(startWith(foundCourses));
            }
        }
        // Either we have loaded courses info, but not for this one, or we have no loaded courses info at all. Either case, load them now.
        return self.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetAllCoursesAtCollege?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '') + "&SchoolYear=" + (SchoolYear || '')))
            .pipe(map(function (res) {
            if (!res) {
                return null;
            }
            var coldata = {
                CollegeID: res.CollegeID,
                SchoolYear: res.SchoolYear,
                Courses: [],
                Departments: [],
            };
            if (res.Courses && res.Courses.length) {
                res.Courses.forEach(function (data) {
                    var datadata = __assign({}, data);
                    // Set up the full course code for each entry before setting it into the system.
                    datadata.FullCode = datadata.Prefix + ' ' + datadata.Code;
                    coldata.Courses.push(datadata);
                });
            }
            if (res.Departments && res.Departments.length) {
                res.Departments.forEach(function (data) {
                    var datadata = __assign({}, data);
                    if (datadata.Courses && datadata.Courses.length) {
                        datadata.Courses.forEach(function (cdata) {
                            cdata.FullCode = cdata.Prefix + ' ' + cdata.Code;
                        });
                    }
                    coldata.Departments.push(datadata);
                });
            }
            self.CollegeCourses = self.CollegeCourses || [];
            self.CollegeCourses.push(coldata);
            return self.CollegeCourses.length - 1;
        }));
    };
    // #endregion
    // #region Get All Designees Service Call
    ApplicationService.prototype.GetAllDesignees = function (AuthToken, CurrentRole) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetAllDesignees?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '')))
            .pipe(map(function (body) {
            if (body && body.length) {
                body.forEach(function (item) {
                    item.DateAdded = item.DateAdded ? new Date(item.DateAdded) : null;
                });
            }
            return body;
        }));
    };
    // #endregion
    // #region Get All Eligible Courses Service Call
    ApplicationService.prototype.GetAllEligibleCourses = function (AuthToken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/DELTA/GetAllEligibleCourses?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Get All Grad Requirements Service Call
    ApplicationService.prototype.GetAllGradRequirements = function () {
        return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetAllGradRequirements");
    };
    // #endregion
    // #region Get All Issue Reports Service Call
    ApplicationService.prototype.GetAllIssueReports = function (AuthToken, CurrentRole, OriginDate) {
        return this.http
            .get(this.configService.hostAddress + "Api/Services/DELTA/GetAllIssueReports?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&OriginDate=" + (OriginDate ? OriginDate.toJSON() : ''))
            .pipe(map(function (reports) {
            if (reports && !!reports.length) {
                reports.forEach(function (rep) {
                    rep.DateReported = rep.DateReported ? new Date(rep.DateReported) : null;
                    rep.ResolvedDate = rep.ResolvedDate ? new Date(rep.ResolvedDate) : null;
                });
            }
            return reports;
        }));
    };
    // #endregion
    // #region Get All Schools Service Call
    ApplicationService.prototype.GetAllSchools = function (AuthToken, SchoolYear) {
        var self = this;
        if (!this._AllSchools) {
            // We do not have what we need loaded yet. Load it now.
            return this.http
                .get(this.configService.hostAddress +
                ("Api/Services/DELTA/GetAllSchools?AuthToken=" + (AuthToken || '') + "&SchoolYear=" + (SchoolYear || '')))
                .pipe(tap(function (res) {
                self._AllSchools = res;
            }));
        }
        else {
            // We already have the list of all schools. Return it as an observable.
            return of(self._AllSchools);
        }
    };
    // #endregion
    // #region Get All School Years Service Call
    ApplicationService.prototype.GetAllSchoolYears = function () {
        var self = this;
        if (!self._AllSchoolYears) {
            // We do not have what we need loaded yet. Load it now.
            return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetAllSchoolYears").pipe(tap(function (res) {
                var years = res;
                self._AllSchoolYears = years;
                // Process a list of all possible college school years. By design, this will be in 20## format, and will
                // extend to 1 year beyond the current PCPS year.
                // This is to accommodate colleges which refer to their Fall terms as the following year. For example,
                // a class running in Fall of the 2016 calendar year may be referred to as the "Fall 2017" college year.
                var collegeYears = [];
                // If we are in the spring term (January - June), add 1 to the year to ensure we are getting the next available year.
                var today = new Date();
                var offset = getMonth(today) <= 5 ? 1 : 0;
                if (self._AllSchoolYears && self._AllSchoolYears.length) {
                    var endyear = parseInt(years[0].substr(2, 2), 10) + offset;
                    var beginyear = parseInt(years[years.length - 1].substr(2, 2), 10);
                    for (var ci = endyear; ci >= beginyear; ci--) {
                        var newYear = '20' + ('00' + ci).slice(-2);
                        collegeYears.push(newYear);
                    }
                }
                self._AllCollegeYears = collegeYears;
            }));
        }
        else {
            // We already have the list of all school years. Return it as an observable.
            return of(self._AllSchoolYears);
        }
    };
    // #endregion
    // #region Get All School Years For Adoptions Service Call
    ApplicationService.prototype.GetAllSchoolYearsForAdoptions = function () {
        var self = this;
        if (!self._AllSchoolYearsForAdoptions) {
            // We do not have what we need loaded yet. Load it now.
            return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetAllSchoolYearsForAdoptions").pipe(tap(function (res) {
                var years = res;
                self._AllSchoolYearsForAdoptions = years;
            }));
        }
        else {
            // We already have the list of all school years. Return it as an observable.
            return of(self._AllSchoolYearsForAdoptions);
        }
    };
    // #endregion
    // #region Get All Web App Issue Alerts Service Call
    ApplicationService.prototype.GetAllWebAppIssueAlerts = function () {
        return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetAllWebAppIssueAlerts").pipe(map(function (alerts) {
            if (alerts && !!alerts.length) {
                alerts.forEach(function (alert) {
                    alert.DateBegin = alert.DateBegin ? new Date(alert.DateBegin) : null;
                    alert.DateEnd = alert.DateEnd ? new Date(alert.DateEnd) : null;
                    alert.LastUpdated = alert.LastUpdated ? new Date(alert.LastUpdated) : null;
                });
            }
            return alerts;
        }));
    };
    // #endregion
    // #region Get All Web App Issue Alerts In Effect Service Call
    ApplicationService.prototype.GetAllWebAppIssueAlertsInEffect = function () {
        return this.http
            .get(this.configService.hostAddress + "Api/Services/DELTA/GetAllWebAppIssueAlertsInEffect")
            .pipe(map(function (alerts) {
            if (alerts && !!alerts.length) {
                alerts.forEach(function (alert) {
                    alert.DateBegin = alert.DateBegin ? new Date(alert.DateBegin) : null;
                    alert.DateEnd = alert.DateEnd ? new Date(alert.DateEnd) : null;
                    alert.LastUpdated = alert.LastUpdated ? new Date(alert.LastUpdated) : null;
                });
            }
            return alerts;
        }));
    };
    // #endregion
    // #region Get All Web App Issues Service Call
    ApplicationService.prototype.GetAllWebAppIssues = function () {
        return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetAllWebAppIssues");
    };
    // #endregion
    // #region Get Available Terms Service Call
    ApplicationService.prototype.GetAvailableTerms = function (AuthToken, CollegeID, SchoolYear) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetAvailableTerms?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '') + "&SchoolYear=" + (SchoolYear || '')))
            .pipe(map(function (res) {
            var data = res || [];
            data.forEach(function (d) {
                d.DateBegin = d.DateBegin != null ? new Date(d.DateBegin) : null;
                d.DateEnd = d.DateEnd != null ? new Date(d.DateEnd) : null;
            });
            return data;
        }));
    };
    // #endregion
    // #region Get College Agreement Text Service Call
    ApplicationService.prototype.GetCollegeAgreementText = function (AuthToken, CollegeID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetCollegeAgreementText?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '')))
            .pipe(map(function (res) {
            var data = {
                ConsentText: (res && res.ConsentText) || '',
                Text: (res && res.Text) || '',
                Version: res && res.Version,
                DateCreated: res && res.DateCreated ? new Date(res.DateCreated) : null,
                CollegeID: CollegeID,
            };
            return data;
        }));
    };
    // #endregion
    // #region Get College Course Info By ID Service Call
    ApplicationService.prototype.GetCollegeCourseInfoByID = function (AuthToken, CollegeCourseID) {
        return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetCollegeCourseInfoByID?AuthToken=" + (AuthToken || '') + "&CollegeCourseID=" + (CollegeCourseID || ''));
    };
    // #endregion
    // #region Get Current School Year Service Call
    ApplicationService.prototype.GetCurrentSchoolYear = function () {
        var self = this;
        if (!self._CurrentSchoolYear) {
            // We do not have what we need yet loaded. Load it now.
            return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/GetCurrentSchoolYear?AuthToken=").pipe(tap(function (res) {
                var body = res;
                self._CurrentSchoolYear = body;
                if (!self._SelectedSchoolYear) {
                    self._SelectedSchoolYear = self._CurrentSchoolYear;
                }
                // One more thing. If the current date is June 1 - July 15, AND the current school year reported by
                // the system is not the "next" school year, turn on the summer rollover note alert so people won't
                // panic about the school year thing.
                var today = new Date();
                var june1 = parse(getYear(today) + "-06-01");
                var july15 = endOfDay(parse(getYear(today) + "-07-15"));
                if (isWithinRange(today, june1, july15)) {
                    // Check the current year string against the year which just ended.
                    var yearnum = getYear(today) % 1000;
                    var lystr = ('00' + (yearnum - 1)).slice(-2) + ('00' + yearnum).slice(-2);
                    // Set the global appvar accordingly
                    // Show the note if the current year reported still matches the apparent last year
                    self.ShowSummerRolloverNote = self._CurrentSchoolYear === lystr;
                }
            }));
        }
        else {
            // We already have the current school year. Return it as an observable.
            return of(self._CurrentSchoolYear);
        }
    };
    // #endregion
    // #region Get Designee Counselor Rights Service Call
    ApplicationService.prototype.GetDesigneeCounselorRights = function (AuthToken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/DELTA/GetDesigneeCounselorRights?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Get Dual Enrollment Program Info Service Call
    ApplicationService.prototype.GetDualEnrollmentProgramInfo = function (DualEnrollmentProgramID) {
        if (DualEnrollmentProgramID == null) {
            return null;
        }
        if (!this._DualEnrollmentPrograms || !this._DualEnrollmentPrograms.length) {
            return null;
        }
        return (this._DualEnrollmentPrograms.find(function (data) {
            return data.ProgramID === DualEnrollmentProgramID;
        }) || null);
    };
    // #endregion
    // #region Get Dual Enrollment Programs Service Call
    ApplicationService.prototype.GetDualEnrollmentPrograms = function (AuthToken) {
        var self = this;
        if (!self._DualEnrollmentPrograms) {
            // Load what we need.
            return this.http
                .get(this.configService.hostAddress + ("Api/Services/DELTA/GetDualEnrollmentPrograms?AuthToken=" + (AuthToken || '')))
                .pipe(map(function (res) {
                if (res && res.length) {
                    res.forEach(function (data) {
                        data.CreditsText =
                            data.MinimumCredits +
                                (data.MaximumCredits != null ? ' - ' + data.MaximumCredits : '+') +
                                ' credits';
                    });
                }
                return res;
            }), tap(function (res) {
                self._DualEnrollmentPrograms = res;
            }));
        }
        else {
            return of(self._DualEnrollmentPrograms);
        }
    };
    // #endregion
    // #region Get Parent Contact Information Service Call
    ApplicationService.prototype.GetParentContactInformation = function (AuthToken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/DELTA/GetParentContactInformation?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Get School Counselors Service Call
    ApplicationService.prototype.GetSchoolCounselors = function (AuthToken, SchoolNumber) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetSchoolCounselors?AuthToken=" + (AuthToken || '') + "&SchoolNumber=" + (SchoolNumber || '')));
    };
    // #endregion
    // #region Get Student College Information Service Call
    ApplicationService.prototype.GetStudentCollegeInformation = function (AuthToken, StudentID) {
        var self = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetStudentCollegeInformation?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '')))
            .pipe(map(function (res) {
            if (!res) {
                return res;
            }
            var resdata = JSON.parse(JSON.stringify(res));
            resdata.forEach(function (data) {
                // Establish the original counselor SAPID before handing back to client
                data.OriginalCounselorSAPID = data.CounselorSAPID;
                data.DualEnrollmentProgram = self.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                data.AvailableTerms = data.AvailableTerms || [];
                data.AnyOpenTerms =
                    data.AvailableTerms.findIndex(function (item) {
                        return item.CurrentlyAvailable === true;
                    }) >= 0;
                // Process all date objects into dates
                data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                if (data.Term) {
                    data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                    data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                }
                if (data.AvailableTerms && data.AvailableTerms.length) {
                    data.AvailableTerms.forEach(function (d) {
                        d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                        d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                    });
                }
            });
            return resdata;
        }));
    };
    // #endregion
    // #region Get Student College Record Notes Service Call
    ApplicationService.prototype.GetStudentCollegeRecordNotes = function (AuthToken, DualEnrollStudentID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetStudentCollegeRecordNotes?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '')))
            .pipe(map(function (notes) {
            if (!notes || !notes.length) {
                return notes;
            }
            notes.forEach(function (data) {
                data.NoteDate = data.NoteDate != null ? new Date(data.NoteDate) : null;
            });
            return notes;
        }));
    };
    // #endregion
    // #region Get Student Course Choices Service Call
    ApplicationService.prototype.GetStudentCourseChoices = function (AuthToken, DualEnrollStudentID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetStudentCourseChoices?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '')))
            .pipe(map(function (res) {
            var data = (res || []).slice();
            data.forEach(function (d) {
                // Create the full coded name for each course choice returned
                d.FullCode = d.Prefix + ' ' + d.Code;
                d.DateCreated = d.DateCreated ? new Date(d.DateCreated) : null;
                d.DateRemoved = d.DateRemoved ? new Date(d.DateRemoved) : null;
                d.DateScheduled = d.DateScheduled ? new Date(d.DateScheduled) : null;
            });
            return data;
        }));
    };
    // #endregion
    // #region Get Student School Information Service Call
    ApplicationService.prototype.GetStudentSchoolInformation = function (AuthToken, StudentID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetStudentSchoolInformation?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '')))
            .pipe(map(function (res) {
            if (!res) {
                return res;
            }
            var data = JSON.parse(JSON.stringify(res));
            data.BirthDate = data.BirthDate ? new Date(data.BirthDate) : null;
            if (data.TestHistory && data.TestHistory.length) {
                data.TestHistory.forEach(function (d) {
                    (d.Years || []).forEach(function (yr) {
                        (yr.Subjects || []).forEach(function (s) {
                            (s.Exams || []).forEach(function (ex) {
                                ex.TestDate = ex.TestDate ? new Date(ex.TestDate) : null;
                            });
                        });
                    });
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Get Student School Information By Year Service Call
    ApplicationService.prototype.GetStudentSchoolInformationByYear = function (AuthToken, StudentID, SchoolYear) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/GetStudentSchoolInformationByYear?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&SchoolYear=" + (SchoolYear || '')))
            .pipe(map(function (res) {
            if (!res) {
                return res;
            }
            var data = JSON.parse(JSON.stringify(res));
            data.BirthDate = data.BirthDate ? new Date(data.BirthDate) : null;
            if (data.TestHistory && data.TestHistory.length) {
                data.TestHistory.forEach(function (d) {
                    (d.Years || []).forEach(function (yr) {
                        (yr.Subjects || []).forEach(function (s) {
                            (s.Exams || []).forEach(function (ex) {
                                ex.TestDate = ex.TestDate ? new Date(ex.TestDate) : null;
                            });
                        });
                    });
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Get Students For Parent Service Call
    ApplicationService.prototype.GetStudentsForParent = function (AuthToken) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress + ("Api/Services/DELTA/GetStudentsForParent?AuthToken=" + (AuthToken || '')))
            .pipe(tap(function (kids) {
            _this.ParentStudentChildren = kids;
        }));
    };
    // #endregion
    // #region Get Test Thresholds
    ApplicationService.prototype.GetTestThresholds = function (AuthToken) {
        return this.http
            .get(this.configService.hostAddress + ("Api/Services/DELTA/GetTestThresholds?AuthToken=" + (AuthToken || '')))
            .pipe(map(function (data) {
            if (data) {
                data.forEach(function (d) {
                    d.DateUpdated = d.DateUpdated ? new Date(d.DateUpdated) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Parent Approve College Agreement Service Call
    ApplicationService.prototype.ParentApproveCollegeAgreement = function (AuthToken, StudentID, ParentUserID, ParentFocusStaffID, DualEnrollStudentID, CollegeID, SchoolYear, TermWindowID, AsProxy, ProxyParentName, ProxyRelationship, ProxyDescription) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/ParentApproveCollegeAgreement", {
            AuthToken: AuthToken || '',
            StudentID: StudentID || '',
            ParentUserID: ParentUserID || '',
            ParentFocusStaffID: ParentFocusStaffID || '',
            DualEnrollStudentID: DualEnrollStudentID || '',
            CollegeID: CollegeID || '',
            SchoolYear: SchoolYear || '',
            TermWindowID: TermWindowID || '',
            AsProxy: AsProxy || '',
            ProxyParentName: ProxyParentName || '',
            ProxyRelationship: ProxyRelationship || '',
            ProxyDescription: ProxyDescription || '',
        })
            .pipe(map(function (terms) {
            if (terms && !!terms.length) {
                terms.forEach(function (term) {
                    term.DateApproved = term.DateApproved ? new Date(term.DateApproved) : null;
                });
            }
        }));
    };
    // #endregion
    // #region Remove College Contact Service Call
    ApplicationService.prototype.RemoveCollegeContact = function (AuthToken, CollegeContactID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveCollegeContact?AuthToken=" + (AuthToken || '') + "&CollegeContactID=" + (CollegeContactID || '')));
    };
    // #endregion
    // #region Remove College Staff From College Service Call
    ApplicationService.prototype.RemoveCollegeStaffFromCollege = function (AuthToken, StaffID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveCollegeStaffFromCollege?AuthToken=" + (AuthToken || '') + "&StaffID=" + (StaffID || '')));
    };
    // #endregion
    // #region Remove Designee Service Call
    ApplicationService.prototype.RemoveDesignee = function (AuthToken, CurrentRole, DesigneeID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveDesignee?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&DesigneeID=" + (DesigneeID || '')))
            .pipe(map(function (body) {
            if (body && body.length) {
                body.forEach(function (item) {
                    item.DateAdded = item.DateAdded ? new Date(item.DateAdded) : null;
                });
            }
            return body;
        }));
    };
    // #endregion
    // #region Remove Eligible Course Service Call
    ApplicationService.prototype.RemoveEligibleCourse = function (AuthToken, ECourseID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveEligibleCourse?AuthToken=" + (AuthToken || '') + "&ECourseID=" + (ECourseID || '')));
    };
    // #endregion
    // #region Remove Eligible Course College Service Call
    ApplicationService.prototype.RemoveEligibleCourseCollege = function (AuthToken, EligibleCourseID, CollegeID) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/RemoveEligibleCourseCollege", {
            AuthToken: AuthToken || '',
            EligibleCourseID: EligibleCourseID || '',
            CollegeID: CollegeID || '',
        });
    };
    // #endregion
    // #region Remove Student College Record Service Call
    ApplicationService.prototype.RemoveStudentCollegeRecord = function (AuthToken, StudentID, DualEnrollStudentID) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveStudentCollegeRecord?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '')))
            .pipe(map(function (res) {
            var resdata = (res || []).slice();
            resdata.forEach(function (data) {
                data.OriginalCounselorSAPID = data.CounselorSAPID;
                data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                data.AvailableTerms = data.AvailableTerms || [];
                data.AnyOpenTerms =
                    data.AvailableTerms.findIndex(function (item) {
                        return item.CurrentlyAvailable === true;
                    }) >= 0;
                // Process all date objects into dates
                data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                if (data.Term) {
                    data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                    data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                }
                if (data.AvailableTerms && data.AvailableTerms.length) {
                    data.AvailableTerms.forEach(function (d) {
                        d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                        d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                    });
                }
            });
            return resdata;
        }));
    };
    // #endregion
    // #region Remove Student College Record Course Service Call
    ApplicationService.prototype.RemoveStudentCollegeRecordCourse = function (AuthToken, CurrentRole, DualEnrollStudentID, CourseChoiceID, RemovedBy) {
        var self = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveStudentCollegeRecordCourse?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CourseChoiceID=" + (CourseChoiceID || '') + "&RemovedBy=" + (RemovedBy || '')))
            .pipe(map(function (res) {
            if (res.Requests && res.Requests.length) {
                res.Requests.forEach(function (data) {
                    // Create the full coded name for each course choice returned
                    data.FullCode = data.Prefix + ' ' + data.Code;
                    data.DateCreated = data.DateCreated ? new Date(data.DateCreated) : null;
                    data.DateRemoved = data.DateRemoved ? new Date(data.DateRemoved) : null;
                    data.DateScheduled = data.DateScheduled ? new Date(data.DateScheduled) : null;
                });
            }
            if (res.Notes && res.Notes.length) {
                res.Notes.forEach(function (note) {
                    note.NoteDate = note.NoteDate ? new Date(note.NoteDate) : null;
                });
            }
            return res;
        }));
    };
    // #endregion
    // #region Remove Student College Record Note Service Call
    ApplicationService.prototype.RemoveStudentCollegeRecordNote = function (AuthToken, DualEnrollStudentID, NoteID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveStudentCollegeRecordNote?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&NoteID=" + (NoteID || '')))
            .pipe(map(function (res) {
            var data = (res || []).slice();
            data.forEach(function (item) {
                item.NoteDate = item.NoteDate ? new Date(item.NoteDate) : null;
            });
            return data;
        }));
    };
    // #endregion
    // #region Remove Term Window From College Service Call
    ApplicationService.prototype.RemoveTermWindowFromCollege = function (AuthToken, TermWindowID) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveTermWindowFromCollege?AuthToken=" + (AuthToken || '') + "&TermWindowID=" + (TermWindowID || '')))
            .pipe(map(function (res) {
            var data = res || [];
            data.forEach(function (d) {
                d.DateBegin = d.DateBegin != null ? new Date(d.DateBegin) : null;
                d.DateEnd = d.DateEnd != null ? new Date(d.DateEnd) : null;
            });
            return data;
        }));
    };
    // #endregion
    // #region Remove Test Threshold
    ApplicationService.prototype.RemoveTestThreshold = function (AuthToken, CurrentRole, TestThresholdID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/RemoveTestThreshold?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&TestThresholdID=" + (TestThresholdID || '')));
    };
    // #endregion
    // #region Remove Web App Issue Alert Service Call
    ApplicationService.prototype.RemoveWebAppIssueAlert = function (AuthToken, CurrentRole, WebAppIssueAlertID) {
        return this.http
            .get(this.configService.hostAddress + "Api/Services/DELTA/RemoveWebAppIssueAlert?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&WebAppIssueAlertID=" + (WebAppIssueAlertID || ''))
            .pipe(map(function (alerts) {
            if (alerts && !!alerts.length) {
                alerts.forEach(function (alert) {
                    alert.DateBegin = alert.DateBegin ? new Date(alert.DateBegin) : null;
                    alert.DateEnd = alert.DateEnd ? new Date(alert.DateEnd) : null;
                    alert.LastUpdated = alert.LastUpdated ? new Date(alert.LastUpdated) : null;
                });
            }
            return alerts;
        }));
    };
    // #endregion
    // #region Remove Web App Issue Type Service Call
    ApplicationService.prototype.RemoveWebAppIssueType = function (AuthToken, CurrentRole, IssueID) {
        return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/RemoveWebAppIssueType?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&IssueID=" + (IssueID || ''));
    };
    // #endregion
    // #region Resolve Issue Report Service Call
    ApplicationService.prototype.ResolveIssueReport = function (AuthToken, CurrentRole, IssueID, ResolverComments) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/ResolveIssueReport", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            IssueID: IssueID || '',
            ResolverComments: ResolverComments || '',
        })
            .pipe(map(function (reports) {
            if (reports && !!reports.length) {
                reports.forEach(function (rep) {
                    rep.DateReported = rep.DateReported ? new Date(rep.DateReported) : null;
                    rep.ResolvedDate = rep.ResolvedDate ? new Date(rep.ResolvedDate) : null;
                });
            }
            return reports;
        }));
    };
    // #endregion
    // #region Schedule Student College Record Course Service Call
    ApplicationService.prototype.ScheduleStudentCollegeRecordCourse = function (AuthToken, DualEnrollStudentID, CourseChoiceID, ScheduledBy, ReferenceNumber, CountyTaught) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/ScheduleStudentCollegeRecordCourse?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CourseChoiceID=" + (CourseChoiceID || '') + "&ScheduledBy=" + (ScheduledBy || '') + "&ReferenceNumber=" + (ReferenceNumber || '') + "&CountyTaught=" + (CountyTaught != null ? CountyTaught : '')))
            .pipe(map(function (res) {
            if (res) {
                var data = res.Requests;
                if (data && !!data.length) {
                    data.forEach(function (d) {
                        // Create the full coded name for each course choice returned
                        d.FullCode = d.Prefix + ' ' + d.Code;
                        d.DateCreated = d.DateCreated ? new Date(d.DateCreated) : null;
                        d.DateRemoved = d.DateRemoved ? new Date(d.DateRemoved) : null;
                        d.DateScheduled = d.DateScheduled ? new Date(d.DateScheduled) : null;
                    });
                }
                if (res.Notes && res.Notes.length) {
                    res.Notes.forEach(function (note) {
                        note.NoteDate = note.NoteDate ? new Date(note.NoteDate) : null;
                    });
                }
            }
            return res;
        }));
    };
    // #endregion
    // #region School Admin Update Student College Record Service Call
    ApplicationService.prototype.SchoolAdminUpdateStudentCollegeRecord = function (AuthToken, StudentID, DualEnrollStudentID, AdminSAPID, FormStatus) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/SchoolAdminUpdateStudentCollegeRecord?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&AdminSAPID=" + (AdminSAPID || '') + "&FormStatus=" + (FormStatus || '')))
            .pipe(map(function (res) {
            var resdata = (res || []).slice();
            resdata.forEach(function (data) {
                data.OriginalCounselorSAPID = data.CounselorSAPID;
                data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                data.AvailableTerms = data.AvailableTerms || [];
                data.AnyOpenTerms =
                    data.AvailableTerms.findIndex(function (item) {
                        return item.CurrentlyAvailable === true;
                    }) >= 0;
                // Process all date objects into dates
                data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                if (data.Term) {
                    data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                    data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                }
                if (data.AvailableTerms && data.AvailableTerms.length) {
                    data.AvailableTerms.forEach(function (d) {
                        d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                        d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                    });
                }
            });
            return resdata;
        }));
    };
    // #endregion
    // #region School Counselor Update Student College Record Service Call
    ApplicationService.prototype.SchoolCounselorUpdateStudentCollegeRecord = function (AuthToken, StudentID, DualEnrollStudentID, CounselorSAPID, FormStatus, AsAdminBypass) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/SchoolCounselorUpdateStudentCollegeRecord?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CounselorSAPID=" + (CounselorSAPID || '') + "&FormStatus=" + (FormStatus || '') + "&BypassAdmin=" + (AsAdminBypass || '')))
            .pipe(map(function (res) {
            var resdata = (res || []).slice();
            resdata.forEach(function (data) {
                data.OriginalCounselorSAPID = data.CounselorSAPID;
                data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                data.AvailableTerms = data.AvailableTerms || [];
                data.AnyOpenTerms =
                    data.AvailableTerms.findIndex(function (item) {
                        return item.CurrentlyAvailable === true;
                    }) >= 0;
                // Process all date objects into dates
                data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                if (data.Term) {
                    data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                    data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                }
                if (data.AvailableTerms && data.AvailableTerms.length) {
                    data.AvailableTerms.forEach(function (d) {
                        d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                        d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                    });
                }
            });
            return resdata;
        }));
    };
    // #endregion
    // #region Search For College Student Service Call
    ApplicationService.prototype.SearchForCollegeStudent = function (AuthToken, SchoolYear, StudentID, CollegeID, CollegeStudentID, Term, SchoolYear_SIS, GradeLevel, FirstName, LastName, SchoolNumber) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/SearchForCollegeStudent", {
            AuthToken: AuthToken || '',
            SchoolYear: SchoolYear || '',
            StudentID: StudentID || '',
            CollegeID: CollegeID || '',
            CollegeStudentID: CollegeStudentID || '',
            Term: Term || '',
            SchoolYear_SIS: SchoolYear_SIS || '',
            GradeLevel: GradeLevel || '',
            FirstName: FirstName || '',
            LastName: LastName || '',
            SchoolNumber: SchoolNumber || '',
        })
            .pipe(map(function (res) {
            var body = (res || []);
            body.forEach(function (item) {
                item.BirthDate = item.BirthDate ? new Date(item.BirthDate) : null;
            });
            return body;
        }));
    };
    // #endregion
    // #region Search For Student Service Call
    ApplicationService.prototype.SearchForStudent = function (AuthToken, CurrentRole, SchoolYear, SchoolNumber, StudentID, CollegeID, Term, SchoolYear_SIS, GradeLevel, FirstName, LastName) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/SearchForStudent", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            SchoolYear: SchoolYear || '',
            SchoolNumber: SchoolNumber || '',
            StudentID: StudentID || '',
            CollegeID: CollegeID || '',
            Term: Term || '',
            SchoolYear_SIS: SchoolYear_SIS || '',
            GradeLevel: GradeLevel || '',
            FirstName: FirstName || '',
            LastName: LastName || '',
        })
            .pipe(map(function (res) {
            var body = (res || []);
            body.forEach(function (item) {
                item.BirthDate = item.BirthDate ? new Date(item.BirthDate) : null;
            });
            return body;
        }));
    };
    // #endregion
    // #region Search For User Service Call
    ApplicationService.prototype.SearchForUser = function (AuthToken, FirstName, LastName) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/SearchForUser", {
            AuthToken: AuthToken || '',
            FirstName: FirstName || '',
            LastName: LastName || '',
        });
    };
    // #endregion
    // #region Set Current School Service Call
    ApplicationService.prototype.SetCurrentSchool = function (school) {
        this.CurrentSchool = school;
    };
    // #endregion
    // #region Set Selected Student Service Call
    ApplicationService.prototype.SetSelectedStudent = function (AuthToken, student) {
        var self = this;
        if (!student || !AuthToken) {
            return;
        }
        if (!self.SelectedStudent || student.StudentID !== self.SelectedStudent.StudentID) {
            self.SelectedStudent = student;
        }
    };
    // #endregion
    // #region Submit Issue Report Service Call
    ApplicationService.prototype.SubmitIssueReport = function (form) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/SubmitIssueReport", {
            AuthToken: form.AuthToken || '',
            CurrentRole: form.CurrentRole || '',
            IssueID: form.IssueID || '',
            IssueDescription: form.IssueDescription || '',
            ReporterEmail: form.ReporterEmail || '',
        });
    };
    // #endregion
    // #region Test Email Service Call
    ApplicationService.prototype.TestEmail = function (authToken, template, email, message) {
        if (message === void 0) { message = null; }
        return this.http.post(this.configService.hostAddress + "Api/Services/AdminSettings/TestEmail", {
            AuthToken: authToken || '',
            Template: template || '',
            Email: email || '',
            Message: message || 'TEST: No Message Sent',
        });
    };
    // #endregion
    // #region Undo Remove Student College Record Course Service Call
    ApplicationService.prototype.UndoRemoveStudentCollegeRecordCourse = function (AuthToken, DualEnrollStudentID, CourseChoiceID, AddedBy) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UndoRemoveStudentCollegeRecordCourse?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CourseChoiceID=" + (CourseChoiceID || '') + "&AddedBy=" + (AddedBy || '')))
            .pipe(map(function (res) {
            if (!res) {
                return res;
            }
            var body = res.slice();
            body.forEach(function (data) {
                // Create the full coded name for each course choice returned
                data.FullCode = data.Prefix + ' ' + data.Code;
                data.DateCreated = data.DateCreated ? new Date(data.DateCreated) : null;
                data.DateRemoved = data.DateRemoved ? new Date(data.DateRemoved) : null;
                data.DateScheduled = data.DateScheduled ? new Date(data.DateScheduled) : null;
            });
            return body;
        }));
    };
    // #endregion
    // #region Update College Contact Info Service Call
    ApplicationService.prototype.UpdateCollegeContact = function (AuthToken, CollegeContactID, CollegeID, Email) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateCollegeContact?AuthToken=" + (AuthToken || '') + "\n                &CollegeContactID=" + (CollegeContactID != null ? CollegeContactID : '') + "&CollegeID=" + (CollegeID != null ? CollegeID : '') + "&Email=" + (Email || '')));
    };
    // #endregion
    // #region Update College Staff Access Level Service Call
    ApplicationService.prototype.UpdateCollegeStaffAccessLevel = function (AuthToken, CurrentRole, StaffID, AccessLevel) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateCollegeStaffAccessLevel?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&StaffID=" + (StaffID != null ? StaffID : '') + "&AccessLevel=" + (AccessLevel != null ? AccessLevel : '')));
    };
    // #endregion
    // #region Update College Staff Access Level Service Call
    ApplicationService.prototype.UpdateStudentCompletedOrientation = function (AuthToken, DualEnrollStudentID, StudentID, CollegeID, CompletedOrientation) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentCompletedOrientation?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&StudentID=" + (StudentID || '') + "&CollegeID=" + (CollegeID || '') + "&CompletedOrientation=" + (CompletedOrientation != null ? CompletedOrientation : '')))
            .pipe(map(function (data) {
            data.OriginalCounselorSAPID = data.CounselorSAPID;
            data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
            data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
            data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
            data.AvailableTerms = data.AvailableTerms || [];
            data.AnyOpenTerms =
                data.AvailableTerms.findIndex(function (item) {
                    return item.CurrentlyAvailable === true;
                }) >= 0;
            // Process all date objects into dates
            data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
            data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
            data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
            data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
            data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
            data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
            if (data.Term) {
                data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
            }
            if (data.AvailableTerms && data.AvailableTerms.length) {
                data.AvailableTerms.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Update Parent Contact Info Service Call
    ApplicationService.prototype.UpdateParentContactInfo = function (AuthToken, UserID, FocusStaffID, Phone, Email) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateParentContactInfo?AuthToken=" + (AuthToken || '') + "&UserID=" + (UserID || '') + "&FocusStaffID=" + (FocusStaffID || '') + "&Phone=" + (Phone || '') + "&Email=" + (Email || '')));
    };
    // #endregion
    // #region Update Student College Student ID Service Call
    ApplicationService.prototype.UpdateStudentCollegeStudentID = function (AuthToken, CollegeID, StudentID, CollegeStudentID) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentCollegeStudentID?AuthToken=" + (AuthToken || '') + "&CollegeID=" + (CollegeID || '') + "&StudentID=" + (StudentID || '') + "&StudentIdAtCollege=" + (CollegeStudentID || '')));
    };
    // #endregion
    // #region Update Student College Record Service Call
    ApplicationService.prototype.UpdateStudentCollegeRecord = function (AuthToken, StudentID, DualEnrollStudentID, CounselorSAPID, FormStatus) {
        var self = this;
        return this.http
            .get(self.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentCollegeRecord?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CounselorSAPID=" + (CounselorSAPID || '') + "&FormStatus=" + (FormStatus || '')))
            .pipe(map(function (res) {
            if (!res) {
                return res;
            }
            var resdata = JSON.parse(JSON.stringify(res));
            resdata.forEach(function (data) {
                // Establish the original counselor SAPID before handing back to client
                data.OriginalCounselorSAPID = data.CounselorSAPID;
                data.DualEnrollmentProgram = self.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
                data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
                data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
                data.AvailableTerms = data.AvailableTerms || [];
                data.AnyOpenTerms =
                    data.AvailableTerms.findIndex(function (item) {
                        return item.CurrentlyAvailable === true;
                    }) >= 0;
                // Process all date objects into dates
                data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
                data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
                data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
                data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
                data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
                data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
                if (data.Term) {
                    data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                    data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
                }
                if (data.AvailableTerms && data.AvailableTerms.length) {
                    data.AvailableTerms.forEach(function (d) {
                        d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                        d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                    });
                }
            });
            return resdata;
        }));
    };
    // #endregion
    // #region Update Student College Record Course Reference Number
    ApplicationService.prototype.UpdateStudentCollegeRecordCourseReferenceNumber = function (AuthToken, DualEnrollStudentID, CourseChoiceID, UpdatedBy, ReferenceNumber, CountyTaught) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentCollegeRecordCourseReferenceNumber?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CourseChoiceID=" + (CourseChoiceID || '') + "&UpdatedBy=" + (UpdatedBy || '') + "&ReferenceNumber=" + (ReferenceNumber || '') + "&CountyTaught=" + (CountyTaught != null ? CountyTaught : '')))
            .pipe(map(function (res) {
            if (res) {
                var data = res.Requests;
                if (data && !!data.length) {
                    data.forEach(function (d) {
                        // Create the full coded name for each course choice returned
                        d.FullCode = d.Prefix + ' ' + d.Code;
                        d.DateCreated = d.DateCreated ? new Date(d.DateCreated) : null;
                        d.DateRemoved = d.DateRemoved ? new Date(d.DateRemoved) : null;
                        d.DateScheduled = d.DateScheduled ? new Date(d.DateScheduled) : null;
                    });
                }
                if (res.Notes && res.Notes.length) {
                    res.Notes.forEach(function (note) {
                        note.NoteDate = note.NoteDate ? new Date(note.NoteDate) : null;
                    });
                }
            }
            return res;
        }));
    };
    // #endregion
    // #region Update Student College Record Course Alt Reference Number
    ApplicationService.prototype.UpdateStudentCollegeRecordCourseAltReferenceNumber = function (AuthToken, DualEnrollStudentID, CourseChoiceID, UpdatedBy, ReferenceNumber) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentCollegeRecordCourseAltReferenceNumber?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&CourseChoiceID=" + (CourseChoiceID || '') + "&UpdatedBy=" + (UpdatedBy || '') + "&AltReferenceNumber=" + (ReferenceNumber || '')))
            .pipe(map(function (res) {
            if (res) {
                var data = res.Requests;
                if (data && !!data.length) {
                    data.forEach(function (d) {
                        // Create the full coded name for each course choice returned
                        d.FullCode = d.Prefix + ' ' + d.Code;
                        d.DateCreated = d.DateCreated ? new Date(d.DateCreated) : null;
                        d.DateRemoved = d.DateRemoved ? new Date(d.DateRemoved) : null;
                        d.DateScheduled = d.DateScheduled ? new Date(d.DateScheduled) : null;
                    });
                }
                if (res.Notes && res.Notes.length) {
                    res.Notes.forEach(function (note) {
                        note.NoteDate = note.NoteDate ? new Date(note.NoteDate) : null;
                    });
                }
            }
            return res;
        }));
    };
    // #endregion
    // #region Update Student Contact Info Service Call
    ApplicationService.prototype.UpdateStudentContactInfo = function (AuthToken, StudentID, Phone, Email) {
        return this.http.get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentContactInfo?AuthToken=" + (AuthToken || '') + "&StudentID=" + (StudentID || '') + "&Phone=" + (Phone || '') + "&Email=" + (Email || '')));
    };
    // #endregion
    // #region Update Student Eligibility Service Call
    ApplicationService.prototype.UpdateStudentEligibility = function (AuthToken, DualEnrollStudentID, Eligibility) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentEligibility?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&Eligibility=" + (Eligibility != null ? Eligibility : '')))
            .pipe(map(function (data) {
            data.OriginalCounselorSAPID = data.CounselorSAPID;
            data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
            data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
            data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
            data.AvailableTerms = data.AvailableTerms || [];
            data.AnyOpenTerms =
                data.AvailableTerms.findIndex(function (item) {
                    return item.CurrentlyAvailable === true;
                }) >= 0;
            // Process all date objects into dates
            data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
            data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
            data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
            data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
            data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
            data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
            if (data.Term) {
                data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
            }
            if (data.AvailableTerms && data.AvailableTerms.length) {
                data.AvailableTerms.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Update Student FastTrack Service Call
    ApplicationService.prototype.UpdateStudentFastTrack = function (AuthToken, DualEnrollStudentID, FastTrack) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentFastTrack?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&FastTrackAdvised=" + (FastTrack != null ? FastTrack : '')))
            .pipe(map(function (data) {
            data.OriginalCounselorSAPID = data.CounselorSAPID;
            data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
            data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
            data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
            data.AvailableTerms = data.AvailableTerms || [];
            data.AnyOpenTerms =
                data.AvailableTerms.findIndex(function (item) {
                    return item.CurrentlyAvailable === true;
                }) >= 0;
            // Process all date objects into dates
            data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
            data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
            data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
            data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
            data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
            data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
            if (data.Term) {
                data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
            }
            if (data.AvailableTerms && data.AvailableTerms.length) {
                data.AvailableTerms.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Update Student Program Service Call
    ApplicationService.prototype.UpdateStudentProgram = function (AuthToken, DualEnrollStudentID, DualEnrollmentProgramID, AcceleratedDegreeProgramID) {
        var _this = this;
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateStudentProgram?AuthToken=" + (AuthToken || '') + "&DualEnrollStudentID=" + (DualEnrollStudentID || '') + "&DualEnrollmentProgramID=" + (DualEnrollmentProgramID || '') + "&AcceleratedDegreeProgramID=" + (AcceleratedDegreeProgramID || '')))
            .pipe(map(function (data) {
            data.OriginalCounselorSAPID = data.CounselorSAPID;
            data.DualEnrollmentProgram = _this.GetDualEnrollmentProgramInfo(data.DualEnrollmentProgramID);
            data.OriginalDualEnrollmentProgramID = data.DualEnrollmentProgramID;
            data.OriginalAcceleratedDegreeProgramID = data.AcceleratedDegreeProgramID;
            data.AvailableTerms = data.AvailableTerms || [];
            data.AnyOpenTerms =
                data.AvailableTerms.findIndex(function (item) {
                    return item.CurrentlyAvailable === true;
                }) >= 0;
            // Process all date objects into dates
            data.AgreementTextDate = data.AgreementTextDate ? new Date(data.AgreementTextDate) : null;
            data.CollegeApprovedDate = data.CollegeApprovedDate ? new Date(data.CollegeApprovedDate) : null;
            data.CounselorApprovedDate = data.CounselorApprovedDate ? new Date(data.CounselorApprovedDate) : null;
            data.DateUpdated = data.DateUpdated ? new Date(data.DateUpdated) : null;
            data.ParentApprovedDate = data.ParentApprovedDate ? new Date(data.ParentApprovedDate) : null;
            data.SchoolApprovedDate = data.SchoolApprovedDate ? new Date(data.SchoolApprovedDate) : null;
            if (data.Term) {
                data.Term.DateBegin = data.Term.DateBegin ? new Date(data.Term.DateBegin) : null;
                data.Term.DateEnd = data.Term.DateEnd ? new Date(data.Term.DateEnd) : null;
            }
            if (data.AvailableTerms && data.AvailableTerms.length) {
                data.AvailableTerms.forEach(function (d) {
                    d.DateBegin = d.DateBegin ? new Date(d.DateBegin) : null;
                    d.DateEnd = d.DateEnd ? new Date(d.DateEnd) : null;
                });
            }
            return data;
        }));
    };
    // #endregion
    // #region Update Term Window For College Service Call
    ApplicationService.prototype.UpdateTermWindowForCollege = function (AuthToken, TermWindowID, CollegeSchoolYear, TermCode, DateBegin, DateEnd) {
        return this.http
            .get(this.configService.hostAddress +
            ("Api/Services/DELTA/UpdateTermWindowForCollege?AuthToken=" + (AuthToken || '') + "&TermWindowID=" + (TermWindowID || '') + "&CollegeSchoolYear=" + (CollegeSchoolYear || '') + "&TermCode=" + (TermCode || '') + "&DateBegin=" + (DateBegin != null ? DateBegin.toJSON() : '') + "&DateEnd=" + (DateEnd != null ? DateEnd.toJSON() : '')))
            .pipe(map(function (res) {
            var data = res || [];
            data.forEach(function (d) {
                d.DateBegin = d.DateBegin != null ? new Date(d.DateBegin) : null;
                d.DateEnd = d.DateEnd != null ? new Date(d.DateEnd) : null;
            });
            return data;
        }));
    };
    // #endregion
    // #region Update Test Threshold
    ApplicationService.prototype.UpdateTestThreshold = function (AuthToken, CurrentRole, testInfo, user) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/UpsertTestThreshold", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            TestThresholdID: testInfo.TestThresholdID,
            TestDescription: testInfo.TestDescription || '',
            ContentCode: testInfo.ContentCode || '',
            Description: testInfo.Description || '',
            TestName: testInfo.TestName || '',
            ScoreType: testInfo.ScoreType || '',
            Score: testInfo.Score,
            Active: testInfo.Active,
            DateUpdated: new Date().toISOString(),
            UpdatedBy: user.UserID,
            UpdatedByLastName: user.LastName || '',
            UpdatedByFirstName: user.FirstName || '',
            UpdatedByLocalJobTitle: user.LocalJobTitle || '',
        });
    };
    // #endregion
    // #region Update Web App Issue Alert Service Call
    ApplicationService.prototype.UpdateWebAppIssueAlert = function (AuthToken, CurrentRole, WebAppIssueAlertID, AlertMessage, DateBegin, DateEnd) {
        return this.http
            .post(this.configService.hostAddress + "Api/Services/DELTA/UpdateWebAppIssueAlert", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            WebAppIssueAlertID: WebAppIssueAlertID || '',
            AlertMessage: AlertMessage || '',
            DateBegin: DateBegin ? DateBegin.toISOString() : '',
            DateEnd: DateEnd ? DateEnd.toISOString() : '',
        })
            .pipe(map(function (alerts) {
            if (alerts && !!alerts.length) {
                alerts.forEach(function (alert) {
                    alert.DateBegin = alert.DateBegin ? new Date(alert.DateBegin) : null;
                    alert.DateEnd = alert.DateEnd ? new Date(alert.DateEnd) : null;
                    alert.LastUpdated = alert.LastUpdated ? new Date(alert.LastUpdated) : null;
                });
            }
            return alerts;
        }));
    };
    // #endregion
    // #region Update Web App Issue Sort Order Service Call
    ApplicationService.prototype.UpdateWebAppIssueSortOrder = function (AuthToken, CurrentRole, IssueID, SortOrder) {
        return this.http.get(this.configService.hostAddress + "Api/Services/DELTA/UpdateWebAppIssueSortOrder?AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (CurrentRole || '') + "&IssueID=" + (IssueID || '') + "&SortOrder=" + (SortOrder || ''));
    };
    // #endregion
    // #region Update Web App Issue Type Service Call
    ApplicationService.prototype.UpdateWebAppIssueType = function (AuthToken, CurrentRole, IssueID, DisplayText, RequiresDescription, SortOrder) {
        return this.http.post(this.configService.hostAddress + "Api/Services/DELTA/UpdateWebAppIssueType", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            IssueID: IssueID || '',
            DisplayText: DisplayText || '',
            RequiresDescription: RequiresDescription || '',
            SortOrder: SortOrder || '',
        });
    };
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_AcceleratedPrograms", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllCollegeYears", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllColleges", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSchools", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSchoolYears", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_AllSchoolYearsForAdoptions", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", String)
    ], ApplicationService.prototype, "_CurrentSchoolYear", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", String)
    ], ApplicationService.prototype, "_CurrentSchool", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Array)
    ], ApplicationService.prototype, "_DualEnrollmentPrograms", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Number)
    ], ApplicationService.prototype, "_SelectedAdminCollegeID", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", String)
    ], ApplicationService.prototype, "_SelectedSchoolYear", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", StudentInfo)
    ], ApplicationService.prototype, "_SelectedStudent", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Boolean)
    ], ApplicationService.prototype, "ShowSummerRolloverNote", void 0);
    return ApplicationService;
}());
export { ApplicationService };
// #region Custom Classes
// #region Add Student College Record Return Class
var AddStudentCollegeRecordReturn = /** @class */ (function () {
    function AddStudentCollegeRecordReturn() {
    }
    return AddStudentCollegeRecordReturn;
}());
export { AddStudentCollegeRecordReturn };
// #endregion
// #region Adoption Request Info Class
var AdoptionRequestInfo = /** @class */ (function () {
    function AdoptionRequestInfo() {
    }
    return AdoptionRequestInfo;
}());
export { AdoptionRequestInfo };
// #endregion
// #region Basic Student Info Class
var BasicStudentInfo = /** @class */ (function () {
    function BasicStudentInfo() {
    }
    return BasicStudentInfo;
}());
export { BasicStudentInfo };
// #endregion
// #region College Agreement Class
var CollegeAgreement = /** @class */ (function () {
    function CollegeAgreement() {
    }
    return CollegeAgreement;
}());
export { CollegeAgreement };
// #endregion
// #region College Agreement Approval Info Class
var CollegeAgreementApprovalInfo = /** @class */ (function () {
    function CollegeAgreementApprovalInfo() {
    }
    return CollegeAgreementApprovalInfo;
}());
export { CollegeAgreementApprovalInfo };
// #endregion
// #region College Info Class
var CollegeContactInfo = /** @class */ (function () {
    function CollegeContactInfo() {
    }
    return CollegeContactInfo;
}());
export { CollegeContactInfo };
// #endregion
// #region College Course Info Class
var CollegeCourseInfo = /** @class */ (function () {
    function CollegeCourseInfo() {
    }
    return CollegeCourseInfo;
}());
export { CollegeCourseInfo };
// #endregion
// #region College Courses List Info Class
var CollegeCoursesListInfo = /** @class */ (function () {
    function CollegeCoursesListInfo() {
    }
    return CollegeCoursesListInfo;
}());
export { CollegeCoursesListInfo };
// #endregion
// #region College Department Info CLass
var CollegeDepartmentInfo = /** @class */ (function () {
    function CollegeDepartmentInfo() {
    }
    return CollegeDepartmentInfo;
}());
export { CollegeDepartmentInfo };
// #endregion
// #region College Info Class
var CollegeInfo = /** @class */ (function () {
    function CollegeInfo() {
    }
    return CollegeInfo;
}());
export { CollegeInfo };
// #endregion
// #region College Record Note Class
var CollegeRecordNote = /** @class */ (function () {
    function CollegeRecordNote() {
    }
    return CollegeRecordNote;
}());
export { CollegeRecordNote };
// #endregion
// #region College Staff Class
var CollegeStaff = /** @class */ (function () {
    function CollegeStaff() {
    }
    return CollegeStaff;
}());
export { CollegeStaff };
// #endregion
// #region College Term Info Class
var CollegeTermInfo = /** @class */ (function () {
    function CollegeTermInfo() {
    }
    return CollegeTermInfo;
}());
export { CollegeTermInfo };
// #endregion
// #region Course Choice Class
var CourseChoice = /** @class */ (function () {
    function CourseChoice() {
    }
    return CourseChoice;
}());
export { CourseChoice };
// #endregion
// #region Course Notes Info Class
var CourseNotesInfo = /** @class */ (function () {
    function CourseNotesInfo() {
    }
    return CourseNotesInfo;
}());
export { CourseNotesInfo };
// #endregion
// #region Designee Info Class
var DesigneeInfo = /** @class */ (function () {
    function DesigneeInfo() {
    }
    return DesigneeInfo;
}());
export { DesigneeInfo };
// #endregion
// #region Designee Rights Info Class
var DesigneeRightsInfo = /** @class */ (function () {
    function DesigneeRightsInfo() {
    }
    return DesigneeRightsInfo;
}());
export { DesigneeRightsInfo };
// #endregion
// #region Eligible Course Info Class
var EligibleCourseInfo = /** @class */ (function () {
    function EligibleCourseInfo() {
    }
    return EligibleCourseInfo;
}());
export { EligibleCourseInfo };
// #endregion
// #region Employee Info Class
var EmployeeInfo = /** @class */ (function () {
    function EmployeeInfo() {
    }
    return EmployeeInfo;
}());
export { EmployeeInfo };
// #endregion
// #region Grad Requirement Info Class
var GradRequirementInfo = /** @class */ (function () {
    function GradRequirementInfo() {
    }
    return GradRequirementInfo;
}());
export { GradRequirementInfo };
// #endregion
// #region Issue Alert Info Class
var IssueAlertInfo = /** @class */ (function () {
    function IssueAlertInfo() {
    }
    return IssueAlertInfo;
}());
export { IssueAlertInfo };
// #endregion
// #region Issue Report Info Class
var IssueReportInfo = /** @class */ (function () {
    function IssueReportInfo() {
    }
    return IssueReportInfo;
}());
export { IssueReportInfo };
// #endregion
// #region New Account Info Class
var NewAccountInfo = /** @class */ (function () {
    function NewAccountInfo() {
    }
    return NewAccountInfo;
}());
export { NewAccountInfo };
// #endregion
// #region Parent Info Class
var ParentInfo = /** @class */ (function () {
    function ParentInfo() {
    }
    return ParentInfo;
}());
export { ParentInfo };
// #endregion
// #region Program Info Class
var ProgramInfo = /** @class */ (function () {
    function ProgramInfo() {
    }
    return ProgramInfo;
}());
export { ProgramInfo };
// #endregion
// #region Role Info Class
var RoleInfo = /** @class */ (function () {
    function RoleInfo() {
    }
    return RoleInfo;
}());
export { RoleInfo };
// #endregion
// #region School Counselor Info Class
var SchoolCounselorInfo = /** @class */ (function () {
    function SchoolCounselorInfo() {
    }
    return SchoolCounselorInfo;
}());
export { SchoolCounselorInfo };
// #endregion
// #region School Info Class
var SchoolInfo = /** @class */ (function () {
    function SchoolInfo() {
    }
    return SchoolInfo;
}());
export { SchoolInfo };
// #endregion
// #region Student Agreements Status Class
var StudentAgreementsStatus = /** @class */ (function () {
    function StudentAgreementsStatus() {
    }
    return StudentAgreementsStatus;
}());
export { StudentAgreementsStatus };
// #endregion
// #region Student College Info Class
var StudentCollegeInfo = /** @class */ (function () {
    function StudentCollegeInfo() {
    }
    return StudentCollegeInfo;
}());
export { StudentCollegeInfo };
// #endregion
// #region Student Contact Info Class
var StudentContactInfo = /** @class */ (function () {
    function StudentContactInfo() {
    }
    return StudentContactInfo;
}());
export { StudentContactInfo };
// #endregion
// #region Student Info Class
var StudentInfo = /** @class */ (function (_super) {
    __extends(StudentInfo, _super);
    function StudentInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StudentInfo;
}(BasicStudentInfo));
export { StudentInfo };
// #endregion
// #region Student Search Result Class
var StudentSearchResult = /** @class */ (function () {
    function StudentSearchResult() {
    }
    return StudentSearchResult;
}());
export { StudentSearchResult };
// #endregion
// #region User Search Result Class
var UserSearchResult = /** @class */ (function () {
    function UserSearchResult() {
    }
    return UserSearchResult;
}());
export { UserSearchResult };
// #endregion
// #region Web App Issue Info Class
var WebAppIssueInfo = /** @class */ (function () {
    function WebAppIssueInfo() {
    }
    return WebAppIssueInfo;
}());
export { WebAppIssueInfo };
// #endregion
// #endregion
// #region Custom Enumerations
// #region College Staff Access Level
export var CollegeStaffAccessLevel;
(function (CollegeStaffAccessLevel) {
    CollegeStaffAccessLevel[CollegeStaffAccessLevel["SUPPORT_STAFF"] = 0] = "SUPPORT_STAFF";
    CollegeStaffAccessLevel[CollegeStaffAccessLevel["ADVISOR"] = 1] = "ADVISOR";
    CollegeStaffAccessLevel[CollegeStaffAccessLevel["ADMINISTRATOR"] = 2] = "ADMINISTRATOR";
})(CollegeStaffAccessLevel || (CollegeStaffAccessLevel = {}));
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/services/application/application.service.ts.pre-build-optimizer.js